import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const ComponentWithCallback = (props) => {
  const { hook, callback, children } = props;

  useEffect(() => {
    if (callback) {
      callback(hook);
    }
  }, [hook, callback]);

  return (
    <>
      {children}
    </>
  );
};

ComponentWithCallback.propTypes = {
  hook: PropTypes.func.isRequired,
  callback: PropTypes.func,
  children: PropTypes.node,
};
ComponentWithCallback.defaultProps = {
  callback: undefined,
  children: null,
};

export const DynamicLoaderFactory = hook => props => <ComponentWithCallback hook={hook} {...props} />;
